import ScheduleListings from "../components/Schedules/SchedulesListings";

export default ScheduleListings;
